import { render, staticRenderFns } from "./_ManifestTransport.vue?vue&type=template&id=06a60c73&scoped=true&"
import script from "./_ManifestTransport.vue?vue&type=script&lang=js&"
export * from "./_ManifestTransport.vue?vue&type=script&lang=js&"
import style0 from "./_ManifestTransport.vue?vue&type=style&index=0&id=06a60c73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a60c73",
  null
  
)

export default component.exports